<script setup>

import { createVNode, ref, onMounted, onUnmounted, getCurrentInstance } from 'vue'

import MainLayout from "@/Layouts/MainLayout.vue";
import { Head }  from '@inertiajs/vue3';
import ProductSliderProvisioner from "@/Components/Misc/ProductSliderProvisioner.vue";
import renderComponent from "@/renderComponent";

const { appContext } = getCurrentInstance();

let destroyComp = null;

onUnmounted(() => destroyComp?.())

// Props
defineProps({
	page : Object
});

// Define available components
const availableComponents = {
	ProductSliderProvisioner
};

// Where all the page content is
const contentContainer = ref(null);

onMounted(() => {

	// Get all the placeholders
	const placeholders = contentContainer.value.querySelectorAll("[data-component]");

	// Loop through all the placeholders
	placeholders.forEach((el) => {

		// Get the attributes of the placeholder: data-something="the value"
		const attributes = Array.from(el.attributes).reduce((acc, attribute) => {
			acc[attribute.name.replace("data-", "")] = attribute.value;
			return acc;
		}, {});

		// Get all attributes except the component name attribute
		const attributesExceptComponent = Object.keys(attributes).filter((key) => key !== "component").reduce((acc, key) => {
			acc[key] = attributes[key];
			return acc;
		}, {});

		// Render the component
		renderComponent({
			el : el,
			component : availableComponents[attributes.component],
			props : attributesExceptComponent,
			appContext
		});

	});

});


</script>

<template>

	<MainLayout>

		<Head>
			<title head-key="title">{{page.meta.title || page.title}}</title>
			<meta name="description" :content="page.meta.description || ''" head-key="description"/>
		</Head>

		<div class="container">
			<div class="row mb-4">
				<div class="col-12 ps-4">
					<h1>{{page.title}}</h1>
				</div>
			</div>
		</div>

		<div class="container" id="page" ref="contentContainer" v-html="page.content"></div>

	</MainLayout>

</template>

<style scoped>

</style>